import { Link } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { WindowsLogo, AppleLogo } from 'phosphor-react';

type Platform = 'windows' | 'mac-silicon' | 'mac-intel';

interface PlatformOption {
  id: Platform;
  label: string;
  icon: React.ElementType;
  downloadUrl: string;
}

const platforms: PlatformOption[] = [
  {
    id: 'windows',
    label: 'Windows',
    icon: WindowsLogo,
    downloadUrl: '#download-windows', // Replace with actual download URL
  },
  {
    id: 'mac-silicon',
    label: 'Mac (Apple Silicon)',
    icon: AppleLogo,
    downloadUrl: '#download-mac-silicon', // Replace with actual download URL
  },
  {
    id: 'mac-intel',
    label: 'Mac (Intel)',
    icon: AppleLogo,
    downloadUrl: '#download-mac-intel', // Replace with actual download URL
  },
];

function detectPlatform(): Platform {
  if (typeof window === 'undefined') return 'windows';

  const userAgent = navigator.userAgent.toLowerCase();
  const platform = navigator.platform?.toLowerCase() || '';

  // Check for Mac
  if (platform.includes('mac') || userAgent.includes('mac')) {
    // Try to detect Apple Silicon vs Intel
    // Apple Silicon Macs report as arm64 or have specific user agent patterns
    const isAppleSilicon =
      userAgent.includes('arm') ||
      // @ts-expect-error - userAgentData is not in all browsers
      navigator.userAgentData?.platform === 'macOS';

    return isAppleSilicon ? 'mac-silicon' : 'mac-intel';
  }

  return 'windows';
}

interface DownloadButtonProps {
  variant?: 'primary' | 'secondary';
  className?: string;
}

export function DownloadButton({ variant = 'secondary', className = '' }: DownloadButtonProps) {
  const [selectedPlatform, setSelectedPlatform] = useState<Platform>('windows');

  useEffect(() => {
    setSelectedPlatform(detectPlatform());
  }, []);

  const currentPlatform = platforms.find(p => p.id === selectedPlatform) || platforms[0];
  const Icon = currentPlatform.icon;

  const baseClasses = variant === 'primary'
    ? 'bg-white text-black hover:bg-zinc-200'
    : 'bg-zinc-900 text-white border border-zinc-800 hover:bg-zinc-800';

  const boxShadow = undefined;

  return (
    <div className={`relative flex flex-col items-center ${className}`}>
      {/* Main Download Button */}
      <Link
        to="/register"
        className={`inline-flex items-center justify-center h-12 px-8 rounded text-sm font-semibold transition-all cursor-pointer ${baseClasses}`}
        style={{ boxShadow }}
      >
        <Icon className="mr-2 w-4 h-4" weight="fill" />
        Começar agora
      </Link>
    </div>
  );
}

// Inline variant without dropdown for CTA
export function DownloadButtonSimple({ className = '' }: { className?: string }) {
  const [selectedPlatform, setSelectedPlatform] = useState<Platform>('windows');

  useEffect(() => {
    setSelectedPlatform(detectPlatform());
  }, []);

  const currentPlatform = platforms.find(p => p.id === selectedPlatform) || platforms[0];
  const Icon = currentPlatform.icon;

  return (
    <Link
      to="/register"
      className={`inline-flex items-center justify-center h-12 px-8 rounded text-sm font-semibold transition-all cursor-pointer bg-white text-black hover:bg-zinc-200 ${className}`}
    >
      <Icon className="mr-2 w-5 h-5" weight="fill" />
      Começar agora
    </Link>
  );
}
